'use client';

import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';

type TraceProps = ComponentPropsWithoutRef<'div'> & {
  nested?: boolean;
  children?: ReactNode;
};

export function Trace({ nested, children, ...rest }: TraceProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      pl={nested ? 3 : undefined}
      borderLeftWidth={nested ? '1px' : undefined}
      borderColor={nested ? 'border.subtle' : undefined}
      {...rest}
    >
      {children}
    </Box>
  );
}
